import { Grid2 as Grid, Typography } from '@mui/material';
import { AuditLogsAccessResponse } from 'api';
import { FlatOption } from 'pages/AuditLogs/types';
import BusinessUnitSelect from './BusinessUnitSelect/BusinessUnitSelect';
import DateRangeFilter from './DateRangeFilter';

export const LogsFilter = ({
  scope,
  handleBusinessEntitySelection,
  handleDateRangeSelection,
}: {
  scope: AuditLogsAccessResponse;
  handleBusinessEntitySelection: (selection: FlatOption | null) => void;
  handleDateRangeSelection: (startDate: Date | null, endDate: Date | null) => void;
}) => (
  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
    <Grid>
      <Typography variant="body1">Filter By</Typography>
    </Grid>
    <Grid>
      <BusinessUnitSelect scope={scope} handleBusinessEntitySelection={handleBusinessEntitySelection} />
    </Grid>
    <Grid container>
      <DateRangeFilter onDateRangeChange={handleDateRangeSelection} />
    </Grid>
  </Grid>
);

export default LogsFilter;
